import { CommandData } from '../../common';

export const open = (trigger?: string) => {
  const message: CommandData = {
    isFromBrainfish: true,
    command: 'openHelpDrawer',
    trigger,
  };
  window.postMessage(message);
};
